// Anish Shah: profile data derived from CV
const profile = {
  name: { first: "Anish", last: "Shah", full: "Anish Shah" },
  roles: {
    short: "Business Analyst",
    detailed: "Business Analyst · Strategy Analyst",
  },
  tagline: "Business Analyst | Strategy Analyst",
  taglineHighlight: "Strategy",
  freelanceNote:
    "Open to Business Analyst, Strategy Analyst and Data-driven Consulting opportunities across the UK.",
  bio:
    "Level-7 Business Analytics professional with 2+ years across strategic analysis, digital transformation and business transformation. I've delivered 50+ client projects and led an 8-member team, converting business ambiguity into clear strategic recommendations for stakeholders. Awarded the Global Futures Scholarship for analytical leadership potential.",
  description:
    "I turn messy business questions into structured analysis, dashboards and recommendations executives can act on.",
  email: "anish.shah0555@gmail.com",
  phone: "+44 7553 994016",
  phoneRaw: "447553994016",
  whatsappBase: "https://wa.me/447553994016",
  location: { based: "United Kingdom", availability: "Worldwide" },
  available: true,
  resumeUrl: "/assets/Anish-Shah-CV.pdf",
  socials: [
    { label: "GitHub", href: "https://github.com/AnishShah26" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/anishshah26" },
    { label: "Email", href: "mailto:anish.shah0555@gmail.com" },
  ],
  pills: [
    "Business Analytics",
    "Strategy",
    "Power BI",
    "Python & SQL",
    "Stakeholder Communication",
  ],
  stats: [
    { value: "2+", label: "Years\nexperience" },
    { value: "50+", label: "Client\nprojects" },
    { value: "8", label: "Team\nled" },
  ],
  specialistStat: { value: "MSc + BE", label: "Business Analytics" },
  skills: [
    "Python", "SQL", "Power BI", "Tableau", "Excel", "R",
    "Data Visualisation", "Statistical Analysis", "Forecasting",
    "MCDA · DEA · MOLP", "Business Strategy", "Digital Transformation",
    "Stakeholder Engagement", "Executive Communication", "Risk Analysis",
  ],
  experience: [
    {
      id: "markscape",
      company: "Markscape Private Limited",
      role: "Business Analyst, Digital Strategy",
      period: "Jan 2023",
      periodEnd: "Mar 2026",
      type: "Full-time",
      location: "Remote · India",
      bullets: [
        "Initiated digital transformation roadmaps across 4 sectors by gathering stakeholder requirements, mapping customer journeys and conducting gap analysis, driving 10% sales enquiry growth.",
        "Architected monthly BI dashboards in Excel and Power BI to track CTR, leads, reach and conversions, yielding 23% digital reach expansion through data-driven optimisation.",
        "Directed Agile project delivery across 50+ client engagements using Jira, sprint planning and Scrum-based tracking, ensuring 100% on-time milestone completion.",
        "Executed full-cycle delivery of 50+ client projects by converting business needs into actionable briefs, monitoring progress and maintaining stakeholder alignment, securing repeat contracts with zero scope creep.",
      ],
      tech: ["Power BI", "Excel", "Digital Strategy", "Agile", "Jira"],
    },
    {
      id: "sofia",
      company: "Technical University of Sofia",
      role: "Research Analyst",
      period: "Jun 2023",
      periodEnd: "Jul 2023",
      type: "Research",
      location: "Sofia, Bulgaria",
      bullets: [
        "Diagnosed a critical data-quality issue by reviewing analytical model outputs and identifying gaps across 10+ datasets, leading to targeted fixes that improved data reliability for downstream reporting.",
        "Executed 1,000+ data validation tests using data cleaning, EDA and output review, improving data integrity across 5+ categories and streamlining the reporting process for the wider team.",
        "Structured 50,000+ records across multiple datasets based on business requirements, enabling cross-functional teams to compare 4 analytical approaches and reducing decision-making time.",
        "Presented findings in 2 executive sessions to 3 key stakeholders, translating complex data into clear, actionable business recommendations that secured buy-in for 2 major strategic initiatives.",
      ],
      tech: ["EDA", "Data Validation", "Data Cleaning", "Research"],
    },
  ],
  education: [
    {
      id: "manchester",
      degree: "MSc Business Analytics: Operational Research & Risk Analysis",
      institution: "University of Manchester",
      location: "Manchester, UK",
      period: "Sep 2025",
      periodEnd: "Sep 2026",
      grade: "Distinction track",
      modules: [
        "Machine Learning for Business",
        "Financial Data Analytics & AI in Finance",
        "Mathematical Programming & Optimisation",
        "Applied Statistics",
        "Data Strategy & Visualisation",
        "Risk & Performance Analytics",
      ],
    },
    {
      id: "mumbai",
      degree: "BE Computer Engineering",
      institution: "University of Mumbai",
      location: "Mumbai, India",
      period: "Jul 2020",
      periodEnd: "Jul 2024",
      grade: "8.53 / 10 · First Class with Distinction",
      modules: [
        "Data Structures & Algorithms",
        "Machine Learning",
        "Database Systems",
        "Software Engineering",
        "Web Technologies",
        "Cloud Computing",
      ],
    },
  ],
  certifications: [
    {
      name: "Forward Program",
      org: "McKinsey.org",
      year: "2025",
      link: "https://www.credly.com/badges/ea5202a7-1a89-4f71-8383-d79a6bf1f6ec/public_url",
    },
    {
      name: "Data Analytics",
      org: "Velocity Corporate Training Centre",
      year: "2025",
      link: "https://drive.google.com/file/d/1gWi2f6W4FKP-NnotRU_KBdx-s0a0tRcy/view",
    },
    {
      name: "Career Essentials in Business Analysis",
      org: "Microsoft & LinkedIn",
      year: "2024",
      link: "https://www.linkedin.com/learning/certificates/b05a9b143b7338f25aa9ef30cb2ef15d37532e4b46eefc37dcf6ad16cfa113f2",
    },
    {
      name: "Power BI Job Simulation",
      org: "PwC · Forage",
      year: "2024",
      link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/PwC%20Switzerland/a87GpgE6tiku7q3gu_PwC%20Switzerland_AaMAn7FwPNBvpAgTD_1723730748374_completion_certificate.pdf",
    },
    {
      name: "Data Analytics & Visualisation Job Simulation",
      org: "Accenture · Forage",
      year: "2024",
      link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Accenture%20North%20America/hzmoNKtzvAzXsEqx8_Accenture%20North%20America_AaMAn7FwPNBvpAgTD_1723435401147_completion_certificate.pdf",
    },
    {
      name: "Excel Skills for Job Simulation",
      org: "Goldman Sachs · Forage",
      year: "2024",
      link: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Goldman%20Sachs/eLeZHcwX7CqLhhps7_Goldman%20Sachs_AaMAn7FwPNBvpAgTD_1725002821512_completion_certificate.pdf",
    },
  ],
  achievements: [
    { name: "Global Futures Scholarship (£8,000)", org: "University of Manchester", year: "2025" },
    { name: "Merit-based scholarship (4×)", org: "Government of Maharashtra", year: "2020-2024" },
    { name: "Vice-Chancellor's Letter of Recommendation", org: "Undergraduate College", year: "2024" },
    { name: "Supervisor's Letter of Recommendation", org: "Technical University of Sofia", year: "2023" },
    { name: "Merit-based scholarship", org: "Technical University of Sofia", year: "2023" },
    { name: "Certificate of Achievement", org: "SK Associates & Group", year: "2023" },
  ],
  publications: [
    {
      id: "scholarship",
      title: "Global Futures Scholarship, £8,000",
      platform: "University of Manchester",
      desc: "Awarded to a select cohort of high-potential postgraduate students on MSc Business Analytics.",
      year: "2025",
      link: "https://www.manchester.ac.uk/",
    },
    {
      id: "merit",
      title: "4× Merit-based scholarships",
      platform: "Government of Maharashtra",
      desc: "Consecutive merit awards across four years of undergraduate study.",
      year: "2020–2024",
      link: "#",
    },
    {
      id: "lor",
      title: "Letter of Recommendation",
      platform: "Vice-Chancellor · Undergraduate College",
      desc: "Recognised for exceptional academic work and leadership contribution.",
      year: "2024",
      link: "#",
    },
    {
      id: "cert",
      title: "Career Essentials in Business Analysis",
      platform: "Microsoft & LinkedIn",
      desc: "Foundational certification covering requirements, stakeholders and analysis techniques.",
      year: "2024",
      link: "#",
    },
  ],
};

export default profile;
